import React from "react";
import "./CourseVideoCard.scss";
import {CalendarIcon, CoursesVideoIcon, VideoCompleteIconBig} from "../assets/icons/defaultIcons";
import {Progress} from "antd";
import dayjs from "dayjs";

const twoColors = {
    "0%": "#40C9A2",
    "100%": "#47f3c2",
};

// Function to convert "HH:MM" or "MM:SS" format to seconds
const timeToSeconds = (timeString) => {
    if (!timeString) return 0;
    const timeParts = timeString.split(":").map(Number);
    return timeParts.length === 2
        ? timeParts[0] * 60 + timeParts[1] // MM:SS format
        : timeParts[0] * 3600 + timeParts[1] * 60 + timeParts[2]; // HH:MM:SS format (if applicable)
};

const CourseVideoCard = ({
  number,
  thumbnail,
  title,
  duration = "09:56",
  current = "0:00",
  date = "01-01-2023",
  onClick
}) => {
  // Convert watched time and total video time to seconds
  const watchedSeconds = timeToSeconds(current);
  const totalSeconds = timeToSeconds(duration);

  // Calculate progress percentage
  const progressPercent = totalSeconds ? Math.min((watchedSeconds / totalSeconds) * 100, 100) : 0;
  
  // Check if duration is missing or "00:00"
  const showProgressBar = duration && duration !== "00:00";

    return (
    <div className={`course-video-card ${progressPercent === 100 && 'completed'}`} onClick={onClick}>
      <div className="card-img">
          <div className={'completed-overlay'}>
              <VideoCompleteIconBig/>
              Completed
          </div>
        {thumbnail ? (
          <img src={thumbnail} alt="Course Video" />
        ) : (
          <div className="demo-placeholder"></div>
        )}
      </div>
      <div className="card-content">
        <div>
            <h4>{title}</h4>
          <h5>
            <span>
                <CalendarIcon /> {dayjs(date).format('MM-DD-YYYY')}
            </span>{" "}
            <span className="video-icon">
              <CoursesVideoIcon />
            </span>
          </h5>
        </div>
        <h6>
          Progress{" "}
          <span>
            <span className="video-watch">{current || "00:00"}</span> |{" "}
            <span className="video-time">{duration || "N/A"}</span>
          </span>
        </h6>

        {showProgressBar && (
          <div className="video-progress">
            {progressPercent === 100 ? (
              // <span className="completed-text">Completed <VideoCompleteIcon /> </span>
                <></>
            ) : (
              <>
                <span>{number ? `#${number}` : "0%"}</span>
                <Progress percent={Math.round(progressPercent)} size={["100%", 7]} strokeColor={twoColors} />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CourseVideoCard;